import { useEffect } from "react";

const MetaTags = ({ title, description }) => {
  useEffect(() => {
    const baseTitle =
      "Amdavad Post: અમદાવાદના તાજા ગુજરાતી સમાચાર, ગુજરાત અને દેશ-દુનિયા Live";
    document.title = `${title} | ${baseTitle}`;

    const existingMetaTag = document.querySelector('meta[name="description"]');
    if (existingMetaTag) {
      existingMetaTag.remove();
    }

    const metaDescriptionTag = document.createElement("meta");
    metaDescriptionTag.name = "description";
    metaDescriptionTag.content = description;
    document.head.appendChild(metaDescriptionTag);

    return () => {
      document.head.removeChild(metaDescriptionTag);
    };
  }, [title, description]);

  return null;
};

export default MetaTags;
